import React, { useEffect } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
// import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import { BsFillPersonBadgeFill, BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../components/MaterialBox";
import MaterialSelect from "../../components/MasterSelect";
import MaterialInput from "../../components/MaterialInput";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialButton from "../../components/MaterialButton";
import { useState } from "react";
import request, { gql } from "graphql-request";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import BASEURL from "../Utils/Baseurl";
import { createLeadProspect } from "../../lib/graphQL/graphMutation";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  leadSourceOptions,
  leadTypeOptions,
  leadStageOptions,
} from "./leadandProspectData";
import {
  addLeadAndProscpectService,
  delteLeadAndProscpectService,
  updateLeadAndProscpectService,
} from "../../lib/appUtliz/LeadandProspectService";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { useLeadAndProscpect } from "../../context/apiContext/Lead-and-ProspectContext";
import { getLeadprospectDetail } from "../../lib/graphQL/graphQuery";
import { useLoading } from "../../context/LodingContext";
import { useError } from "../../context/ErrorContext";
import { useSuccess } from "../../context/SucccessContext";
import { Country, State, City } from "country-state-city";

const LeadAndProspectForm = () => {
  const [selectedData, setSelectedData] = useState([]);
  const [dropDownValues, setDropDownValues] = useState({
    type: "",
    leadSource: "",
    stage: "",
  });
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } =
    useError();
  const [pendingLoading, setPendingLoading] = useState(false);
  const [leadandProspectData, setLeadandProspectData] = useState({
    // leadandProspectData
    firstName: "",
    lastName: "",
    companyName: "",
    mailId: "",
    contactNumber: "",
    secondaryNumber: "",
    jobTitle: "",
    websiteUrl: "",
    companySize: "",
    indutry: "",
    type: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    leadSource: "",
    stage: "",
    status: "",
    lastContactDate: "",
    nextFollowUpdate: "",

    // leadandProspectData status
    statusStatus: "unchecked",
    firstNameStatus: "unchecked",
    lastNameStatus: "unchecked",
    companyNameStatus: "unchecked",
    mailIdStatus: "unchecked",
    contactNumberStatus: "unchecked",
    secondaryNumberStatus: "unchecked",
    jobTitleStatus: "unchecked",
    websiteUrlStatus: "unchecked",
    typeStatus: "unchecked",
    addressLine1Status: "unchecked",
    addressLine2Status: "unchecked",
    stateStatus: "unchecked",
    cityStatus: "unchecked",
    zipCodeStatus: "unchecked",
    leadSourceStatus: "unchecked",
    stageStatus: "unchecked",
    companySizeStatus: "unchecked",
    lastContactDateStatus: "unchecked",
    nextFollowUpdateStatus: "unchecked",
    countryStatus: "unchecked",
    indutryStatus: "unchecked",
  });
  const leadstatusOptions = ["New", "In Progress", "Done"];

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => { },
    onCancel: () => { },
    done: "",
    back: "",
  });
  const navigate = useNavigate();

  const params = useLocation();

  const id = params.search.slice(1);

  const { currentUser } = useAuth();
  const { leadData, setLeadData, isLoading, setIsLoading, status, setStatus } =
    useLeadAndProscpect();

  useEffect(() => {
    if (id) {
      fetchUpdateValue();
    }
  }, [id]);
  useEffect(() => {
    setLeadandProspectData({
      ...leadandProspectData,
      type: { value: "Prospect", label: "Prospect" },
      typeStatus: "success",
    });
  }, []);

  const fetchUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getLeadprospectDetail, {
        id: id,
      });
      const v = res.getLeadprospectDetail;
      // res.filter((v, i) => {
      if (v.id == id) {
        const filterType = leadTypeOptions.filter((type) => {
          if (type.value == v.type) {
            return type;
          }
        });

        const filterLeadSource = leadSourceOptions.filter((source) => {
          if (source.value == v.leadSource) {
            return source;
          }
        });

        const filterStage = leadStageOptions.filter((stage) => {
          if (stage.value == v.stage) {
            return stage;
          }
        });
        setDropDownValues({
          type: filterType.map((user) => {
            return {
              value: user.value,
              label: user.lable,
            };
          }),
          stage: filterStage.map((user) => {
            return {
              value: user.value,
              label: user.lable,
            };
          }),
          leadSource: filterLeadSource.map((user) => {
            return {
              value: user.value,
              label: user.label,
            };
          }),
        });

        setSelectedData(v);
        setLeadandProspectData({
          firstName: v.firstName,
          lastName: v.lastName,
          companyName: v.companyName,
          mailId: v.mailId,
          contactNumber: v.contactNumber,
          secondaryNumber: v.secondaryNumber,
          jobTitle: v.jobTitle,
          websiteUrl: v.websiteUrl,
          companySize: v.companySize,
          indutry: v.indutry,
          type: filterType.map((user) => {
            return {
              value: user.value,
              label: user.lable,
            };
          }),
          addressLine1: v.addressLine1,
          addressLine2: v.addressLine2,
          country: v.country
            ? {
              value: v.country,
              label: v.country,
              isoCode: Country.getAllCountries().find(
                (c) => c.name === v.country
              )?.isoCode,
            }
            : null,
          state: v.state
            ? {
              value: v.state,
              label: v.state,
              isoCode: State.getStatesOfCountry(
                Country.getAllCountries().find((c) => c.name === v.country)
                  ?.isoCode
              ).find((s) => s.name === v.state)?.isoCode,
            }
            : null,
          city: v.city
            ? {
              label: v.city,
              value: v.city,
            }
            : null,
          zipCode: v.zipCode,
          leadSource: filterLeadSource.map((user) => {
            return {
              value: user.value,
              label: user.label,
            };
          }),
          stage: filterStage.map((user) => {
            return {
              value: user.value,
              label: user.lable,
            };
          }),
          status: {
            value: v.status,
            label: v.status,
          },
          lastContactDate: v.lastContactDate,
          nextFollowUpdate: v.nextFollowUpdate,

          // leadandProspectData status

          firstNameStatus: "success",
          lastNameStatus: "success",
          companyNameStatus: "success",
          mailIdStatus: "success",
          contactNumberStatus: "success",
          secondaryNumberStatus: "success",
          jobTitleStatus: "success",
          websiteUrlStatus: "success",
          typeStatus: "success",
          addressLine1Status: "success",
          addressLine2Status: "success",
          stateStatus: "success",
          cityStatus: "success",
          zipCodeStatus: "success",
          leadSourceStatus: "success",
          stageStatus: "success",
          statusStatus: "success",
          companySizeStatus: "success",
          lastContactDateStatus: "success",
          nextFollowUpdateStatus: "success",
          countryStatus: "success",
          indutryStatus: "success",
        });
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setLeadandProspectData({
      firstName: selectedData.firstName,
      lastName: selectedData.lastName,
      companyName: selectedData.companyName,
      mailId: selectedData.mailId,
      contactNumber: selectedData.contactNumber,
      secondaryNumber: selectedData.secondaryNumber,
      jobTitle: selectedData.jobTitle,
      websiteUrl: selectedData.websiteUrl,
      companySize: selectedData.companySize,
      indutry: selectedData.indutry,
      type: dropDownValues.type,
      addressLine1: selectedData.addressLine1,
      addressLine2: selectedData.addressLine2,
      country: { value: selectedData.country, label: selectedData.country },
      state: { value: selectedData.state, label: selectedData.state },
      city: { value: selectedData.city, label: selectedData.city },
      zipCode: selectedData.zipCode,
      leadSource: dropDownValues.leadSource,
      stage: dropDownValues.stage,
      status: {
        value: selectedData.status,
        label: selectedData.status,
      },
      lastContactDate: selectedData.lastContactDate,
      nextFollowUpdate: selectedData.nextFollowUpdate,

      firstNameStatus: "success",
      lastNameStatus: "success",
      companyNameStatus: "success",
      mailIdStatus: "success",
      contactNumberStatus: "success",
      secondaryNumberStatus: "success",
      jobTitleStatus: "success",
      websiteUrlStatus: "success",
      typeStatus: "success",
      addressLine1Status: "success",
      addressLine2Status: "success",
      stateStatus: "success",
      cityStatus: "success",
      zipCodeStatus: "success",
      leadSourceStatus: "success",
      stageStatus: "success",
      statusStatus: "success",
      companySizeStatus: "success",
      lastContactDateStatus: "success",
      nextFollowUpdateStatus: "success",
      countryStatus: "success",
      indutryStatus: "success",
    });
  };

  const handleleadandProspectData = (event, selectEvent) => {
    let leadandProspectState = { ...leadandProspectData };
    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "country") {
        leadandProspectState = {
          ...leadandProspectState,
          country: event,
          state: null,
          city: null,
          stateStatus: "unchecked",
          cityStatus: "unchecked",
          countryStatus: "success",
        };
      } else if (selectEvent.name === "state") {
        leadandProspectState = {
          ...leadandProspectState,
          state: event,
          city: null,
          cityStatus: "unchecked",
          stateStatus: "success",
        };
      } else if (selectEvent.name === "alternateCountry") {
        leadandProspectState = {
          ...leadandProspectState,
          alternateCountry: event,
          alternateState: null,
          alternateCity: null,
          alternateStateStatus: "unchecked",
          alternateCityStatus: "unchecked",
          alternateCountryStatus: "success",
        };
      } else if (selectEvent.name === "alternateState") {
        leadandProspectState = {
          ...leadandProspectState,
          alternateState: event,
          alternateCity: null,
          alternateCityStatus: "unchecked",
          alternateStateStatus: "success",
        };
      } else {
        // Default: city, alternateCity
        leadandProspectState[selectEvent.name] = event;
        if (selectEvent.name) {
          leadandProspectState[`${selectEvent.name}Status`] = "success";
        }
      }

      setLeadandProspectData(leadandProspectState);
    } else if (event) {
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastName":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "companyName":
          {
            const alphaNLenghthRegex = new RegExp("^.{1,100}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mailId":
          {
            const alphaNLenghthRegex = new RegExp(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactNumber": {
          const isNumericRegex = new RegExp("^\\d{1,26}$");
          const maxLength = 25;

          const value = event.target.value?.trim();

          if (!value) {
            leadandProspectState[event.target.name + "Status"] = "unchecked";
          } else if (!isNumericRegex.test(value)) {
            leadandProspectState[event.target.name + "Status"] =
              "nonNumericError";
          } else if (value.length > maxLength) {
            leadandProspectState[event.target.name + "Status"] = "lengthError";
          } else {
            leadandProspectState[event.target.name + "Status"] = "success";
          }
          break;
        }

        case "secondaryNumber": {
          const isNumericRegex = new RegExp("^\\d{1,26}$");
          const maxLength = 25;

          const value = event.target.value?.trim();

          if (!value) {
            leadandProspectState[event.target.name + "Status"] = "unchecked";
          } else if (!isNumericRegex.test(value)) {
            leadandProspectState[event.target.name + "Status"] =
              "nonNumericError";
          } else if (value.length > maxLength) {
            leadandProspectState[event.target.name + "Status"] = "lengthError";
          } else {
            leadandProspectState[event.target.name + "Status"] = "success";
          }
          break;
        }
        case "jobTitle": {
          const alphaWithSpaceRegex = new RegExp("^[A-Za-z ]{3,25}$");
          if (alphaWithSpaceRegex.test(event.target.value?.trim())) {
            leadandProspectState[event.target.name + "Status"] = "success";
          } else {
            leadandProspectState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        }

        case "websiteUrl":
          {
            const alphaNLenghthRegex = new RegExp("^.{5,100}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "companySize":
          {
            const alphaNLenghthRegex = new RegExp("^[A-Za-z0-9]{1,25}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "indutry":
          {
            const alphaNLenghthRegex = new RegExp("^[A-Za-z0-9]{1,30}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "nextFollowUpdate":
          {
            const alphaNLenghthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastContactDate":
          {
            const alphaNLenghthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$"
            );
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "addressLine1":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{5,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "addressLine2":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{5,150}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "country":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "state":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "city":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,30})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipCode":
          {
            const alphaNLenghthRegex = new RegExp("^([ A-Za-z0-9]{6})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              leadandProspectState[event.target.name + "Status"] = "success";
            } else {
              leadandProspectState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        leadandProspectState[event.target.name] = event.target.value;
      }
    }
    setLeadandProspectData(leadandProspectState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      // leadandProspectData.firstNameStatus === "success" &&
      // leadandProspectData.lastNameStatus === "success" &&
      leadandProspectData.companyNameStatus === "success" &&
      (leadandProspectData.mailIdStatus === "success" ||
        leadandProspectData.mailIdStatus === "unchecked") &&
      leadandProspectData.contactNumberStatus === "success" &&
      (leadandProspectData.secondaryNumberStatus === "success" ||
        leadandProspectData.secondaryNumberStatus === "unchecked") &&
      (leadandProspectData.jobTitleStatus === "success" ||
        leadandProspectData.jobTitleStatus === "unchecked") &&
      (leadandProspectData.websiteUrlStatus === "success" ||
        leadandProspectData.websiteUrlStatus === "unchecked") &&
      (leadandProspectData.companySizeStatus === "success" ||
        leadandProspectData.companySizeStatus === "unchecked") &&
      (leadandProspectData.indutryStatus === "success" ||
        leadandProspectData.indutryStatus === "unchecked") &&
      leadandProspectData.typeStatus === "success" &&
      leadandProspectData.nextFollowUpdateStatus === "success" &&
      leadandProspectData.lastContactDateStatus === "success" &&
      leadandProspectData.addressLine1Status === "success" &&
      // leadandProspectData.addressLine2Status === "success" &&
      leadandProspectData.countryStatus === "success" &&
      leadandProspectData.stateStatus === "success" &&
      leadandProspectData.cityStatus === "success" &&
      leadandProspectData.zipCodeStatus === "success" &&
      leadandProspectData.leadSourceStatus === "success" &&
      leadandProspectData.typeStatus === "success"
      // leadandProspectData.statusStatus === "success" &&
      // leadandProspectData.stageStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleEditleadandProspectData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          // user: currentUser?.id,
          firstName: leadandProspectData.firstName,
          lastName: leadandProspectData.lastName,
          companyName: leadandProspectData.companyName,
          mailId: leadandProspectData.mailId,
          contactNumber: leadandProspectData.contactNumber,
          secondaryNumber: leadandProspectData.secondaryNumber,
          jobTitle: leadandProspectData.jobTitle,
          websiteUrl: leadandProspectData.websiteUrl,
          companySize: leadandProspectData.companySize,
          indutry: leadandProspectData.indutry,
          type: Array.isArray(leadandProspectData.type)
            ? leadandProspectData.type[0]?.label
            : leadandProspectData.type?.label,
          addressLine1: leadandProspectData.addressLine1,
          addressLine2: leadandProspectData.addressLine2,
          country: leadandProspectData.country?.value || "",
          state: leadandProspectData.state?.value || "",
          city: leadandProspectData.city?.value || "",
          zipCode: leadandProspectData.zipCode,
          leadSource: Array.isArray(leadandProspectData.leadSource)
            ? leadandProspectData.leadSource[0]?.label
            : leadandProspectData.leadSource?.label,
          stage: Array.isArray(leadandProspectData.stage)
            ? leadandProspectData.stage[0]?.label
            : leadandProspectData.stage?.label,
          status: leadandProspectData.status?.label,
          lastContactDate: leadandProspectData.lastContactDate,
          nextFollowUpdate: leadandProspectData.nextFollowUpdate,
        };

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const { updateStatus, errormessage } =
          await updateLeadAndProscpectService(values, id);
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Prospect Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/leadandprospect");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleCancelLeadData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/leadandprospect");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleAddleadandProspectData = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setCirleLoading(true);
        const values = {
          user: currentUser?.id,
          firstName: leadandProspectData.firstName,
          lastName: leadandProspectData.lastName,
          companyName: leadandProspectData.companyName,
          mailId: leadandProspectData.mailId,
          contactNumber: leadandProspectData.contactNumber,
          secondaryNumber: leadandProspectData.secondaryNumber,
          jobTitle: leadandProspectData.jobTitle,
          websiteUrl: leadandProspectData.websiteUrl,
          companySize: leadandProspectData.companySize,
          indutry: leadandProspectData.indutry,
          type: leadandProspectData.type?.value,
          addressLine1: leadandProspectData.addressLine1,
          addressLine2: leadandProspectData.addressLine2,
          country: leadandProspectData.country?.value || "",
          state: leadandProspectData.state?.value || "",
          city: leadandProspectData.city?.value || "",
          zipCode: leadandProspectData.zipCode,
          leadSource: leadandProspectData.leadSource?.label,
          stage: leadandProspectData.stage?.label,
          status: leadandProspectData.status?.label,
          lastContactDate: leadandProspectData.lastContactDate,
          nextFollowUpdate: leadandProspectData.nextFollowUpdate,
        };
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const { status, errormessage } = await addLeadAndProscpectService(
          values
        );
        setCirleLoading(false);
        // dataStatus ? navigate("/appointment") : alert("err");
        if (status) {
          setSuccessStatus(true);
          setSucessTitle("Prospect Created");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/leadandprospect");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
        // dataStatus ? navigate("/leadandprospect") : alert("err");
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handleDelteLeadandProspect = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your detail.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setPendingLoading(true);
        const delteStatus = await delteLeadAndProscpectService(id);
        setPendingLoading(false);
        if (delteStatus) {
          setSuccessStatus(true);
          setSucessTitle("Prospect Deleted");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/leadandprospect");
          }, 1000);
        } else {
          setErrorStatus(true);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Prospect Details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="gradient"
                    aria-label="Loading button group"
                    size="small"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={handleDelteLeadandProspect}
                      startIcon={<DeleteIcon />}
                    >
                      delete
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Prospect Details
                    </MaterialTypography>
                  </Stack>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Prospect Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
            <BsFillPersonBadgeFill style={{ fontSize: 20, color: '#460058' }} />
            <MaterialTypography
              sx={{ color: '#460058', fontFamily: 'Aptos' }}
              component="label"
              variant="body2"
              fontWeight="700"
            >
              Prospect Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Company Name<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="companyName"
                   size="small"
                  placeholder={!leadandProspectData.companyName ? "Enter the company name" : ""}
                  value={leadandProspectData.companyName}
                  onChange={handleleadandProspectData}
                  onFocus={(e) => e.target.placeholder = ""}
                  onBlur={(e) => e.target.placeholder = "Enter the company name"}
                  error={
                    leadandProspectData.companyNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.companyNameStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.companyNameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Organization Name should have atleast one character
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Website URL<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="text"
                   size="small"
                  name="websiteUrl"
                  placeholder={!leadandProspectData.websiteUrl ? "Enter the websiteUrl" : ""}
                  value={leadandProspectData.websiteUrl}
                  onChange={handleleadandProspectData}
                  onFocus={(e) => e.target.placeholder = ""}
                  onBlur={(e) => e.target.placeholder = "Enter the websiteUrl"}
                  error={
                    leadandProspectData.websiteUrlStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.websiteUrlStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.websiteUrlStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      websiteUrlStatus should be maximum 50 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  // fontWeight="bold"
                  >
                    Job Title<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="jobTitle"
                   size="small"
                  placeholder={!leadandProspectData.jobTitle ? "Enter the jobTitle" : ""}
                  value={leadandProspectData.jobTitle}
                  onChange={handleleadandProspectData}
                  onFocus={(e) => e.target.placeholder = ""}
                  onBlur={(e) => e.target.placeholder = "Enter the jobTitle"}
                  error={
                    leadandProspectData.jobTitleStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.jobTitleStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.jobTitleStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      jobTitle should be maximum 25 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  // fontWeight="bold"
                  >
                    Type<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="type"
                   size="small"
                  value={leadandProspectData.type}
                  defaultValue={leadTypeOptions.find(
                    (option) => option.value === "Prospect"
                  )}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={togglePage?.view === true ? true : false}
                  onChange={handleleadandProspectData} //selectedValue, event
                  options={leadTypeOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.lable,
                    };
                  })}
                  error={
                    leadandProspectData.typeStatus === "error" ? true : false
                  }
                  success={
                    leadandProspectData.typeStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Mail Id<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="mailId"
                   size="small"
                  placeholder={!leadandProspectData.mailId ? "Enter the mailid" : ""}
                  value={leadandProspectData.mailId}
                  onChange={handleleadandProspectData}
                  onFocus={(e) => e.target.placeholder = ""}
                  onBlur={(e) => e.target.placeholder = "Enter the mailid"}
                  error={
                    leadandProspectData.mailIdStatus === "error" ? true : false
                  }
                  success={
                    leadandProspectData.mailIdStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.mailIdStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Email Address
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Prospect Source <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  size="small"
                  name="leadSource"
                  value={leadandProspectData.leadSource}
                  defaultValue={{
                    label: leadandProspectData.leadSource?.label,
                  }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleleadandProspectData} //selectedValue, event
                  isDisabled={togglePage?.view === true ? true : false}
                  options={leadSourceOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={
                    leadandProspectData.leadSourceStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.leadSourceStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Contact Number<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                 size="small"
                  name="contactNumber"
                  placeholder={!leadandProspectData.contactNumber ? "Enter the contact number" : ""}
                  value={leadandProspectData.contactNumber}
                  onChange={handleleadandProspectData}
                  onFocus={(e) => e.target.placeholder = ""}
                  onBlur={(e) => e.target.placeholder = "Enter the contact number"}
                  error={
                    leadandProspectData.contactNumberStatus === "error" ||
                      leadandProspectData.contactNumberStatus ===
                      "nonNumericError" ||
                      leadandProspectData.contactNumberStatus === "lengthError"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.contactNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.contactNumberStatus ===
                  "nonNumericError" && (
                    <FormControl error>
                      <FormHelperText>
                        Contact number should not contain alphabets.
                      </FormHelperText>
                    </FormControl>
                  )}
                {leadandProspectData.contactNumberStatus === "lengthError" && (
                  <FormControl error>
                    <FormHelperText>
                      Contact number should not exceed 25 digits.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Secondary Contact Number
                    <span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="contactNumber"
                   size="small"
                  placeholder={!leadandProspectData.contactNumber ? "Enter the secondary contact number" : ""}
                  value={leadandProspectData.contactNumber}
                  onChange={handleleadandProspectData}
                  onFocus={(e) => e.target.placeholder = ""}
                  onBlur={(e) => e.target.placeholder = "Enter the secondary contact number"}
                  error={
                    leadandProspectData.contactNumberStatus === "error" ||
                      leadandProspectData.contactNumberStatus ===
                      "nonNumericError" ||
                      leadandProspectData.contactNumberStatus === "lengthError"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.contactNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.contactNumberStatus ===
                  "nonNumericError" && (
                    <FormControl error>
                      <FormHelperText>
                        Contact number should not contain alphabets.
                      </FormHelperText>
                    </FormControl>
                  )}
                {leadandProspectData.contactNumberStatus === "lengthError" && (
                  <FormControl error>
                    <FormHelperText>
                      Contact number should not exceed 25 digits.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="15px"
                    fontFamily="Aptos"
                  >
                    Stage <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leadSource"
                   size="small"
                  value={leadandProspectData.leadSource}
                  defaultValue={{
                    label: leadandProspectData.leadSource?.label,
                  }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleleadandProspectData} //selectedValue, event
                  isDisabled={togglePage?.view === true ? true : false}
                  options={leadSourceOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={
                    leadandProspectData.leadSourceStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.leadSourceStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Status <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leadSource"
                   size="small"
                  value={leadandProspectData.leadSource}
                  defaultValue={{
                    label: leadandProspectData.leadSource?.label,
                  }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleleadandProspectData} //selectedValue, event
                  isDisabled={togglePage?.view === true ? true : false}
                  options={leadSourceOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={
                    leadandProspectData.leadSourceStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.leadSourceStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Company Size <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="leadSource"
                  size="small"
                  value={leadandProspectData.leadSource}
                  defaultValue={{
                    label: leadandProspectData.leadSource?.label,
                  }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleleadandProspectData} //selectedValue, event
                  isDisabled={togglePage?.view === true ? true : false}
                  options={leadSourceOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={
                    leadandProspectData.leadSourceStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.leadSourceStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Industry Size <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  size="small"
                  name="leadSource"
                  value={leadandProspectData.leadSource}
                  defaultValue={{
                    label: leadandProspectData.leadSource?.label,
                  }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleleadandProspectData} //selectedValue, event
                  isDisabled={togglePage?.view === true ? true : false}
                  options={leadSourceOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  error={
                    leadandProspectData.leadSourceStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.leadSourceStatus === "success"
                      ? true
                      : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontSize="13px"
                    fontFamily="Aptos"
                  // fontWeight="bold"
                  >
                    Last Contact Date<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  size="small"
                  name="lastContactDate"
                  type="date"
                  placeholder="eg. 01-01-2024"
                  value={leadandProspectData.lastContactDate}
                  onChange={handleleadandProspectData}
                  error={
                    leadandProspectData.lastContactDateStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.lastContactDateStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.lastContactDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}

              </Grid>

              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    // fontWeight="bold"
                    fontSize="13px"
                    fontFamily="Aptos"
                  >
                    Next Follow up Date<span style={{ color: "red" }}> * </span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  size="small"
                  name="nextFollowUpdate"
                  type="date"
                  placeholder="eg. 01-01-2024"
                  value={leadandProspectData.nextFollowUpdate}
                  onChange={handleleadandProspectData}
                  error={
                    leadandProspectData.nextFollowUpdateStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    leadandProspectData.nextFollowUpdateStatus === "success"
                      ? true
                      : false
                  }
                  inputProps={{
                    min: leadandProspectData.lastContactDate,
                  }}
                  disabled={togglePage?.view === true ? true : false}
                />
                {leadandProspectData.nextFollowUpdateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please Enter a Valid Date Of Registration
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>

            </Grid>
          </MaterialBox>
          {/* <Divider /> */}

        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 4.5, }}
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                onClick={handleDiscardButton}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                size="small"
                disabled={!checkAllFields()}
                onClick={handleEditleadandProspectData}
              >
                Update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <Stack spacing={2} direction='row'>
              <MaterialBox p={2} display="flex" gap={2}>
                  <MaterialButton
                    color='dark'
                    variant="contained"
                    size="small"

                    onClick={handleCancelLeadData}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    color='dark'
                    variant="contained"
                                    size="small"

                    onClick={handleAddleadandProspectData}
                  >
                    Submit
                  </MaterialButton>
              </MaterialBox>
            </Stack>
          ) : null}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default LeadAndProspectForm;
